export { ToastTypes, toastState, showToast, hideToast } from '@/services/toast.service';
export type { ToastOptions, ToastType } from '@/services/toast.service';

import { toastState, showToast, hideToast } from '@/services/toast.service';

export function useToast() {
  return {
    toastState,
    showToast,
    hideToast
  };
}
